import React, { useState, useEffect, useRef, useCallback } from "react";
import SidePanel from "../../components/SidePanel";
import draft_img from "../../assets/icons/Draft_IMG.svg";
import Spinner from "../../components/Spinner";
import { format } from "date-fns";
import { SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { getAdjustedEventDate } from "../../utils/sendToPrint";
import MultiSwiper from "../../components/MultiSwiper";
import GenerateCardPopup from "../../components/GenerateCardPopup";

const Draft = () => {
  const swiperRef = useRef({});
  const swiperRef2 = useRef(null);

  const [groupedCards, setGroupedCards] = useState({});
  const [customerCards, setCustomerCards] = useState([]);
  const [loader, setLoader] = useState(false);
  const [cards, setCards] = useState([]);
  const [fav, setFav] = useState([]);
  const [selectedMonthFilter, setSelectedMonthFilter] = useState("");
  const [selectedCardID, setSelectedCardID] = useState("");
  const [selectedCardAddPop, setSelectedCardAddPop] = useState("");
  const [orderModal, setOrderModal] = useState(false);
  const toggleOrderModal = () => {
    setOrderModal(!orderModal);
  };
  const [selectedRecipientNameFilter, setSelectedRecipientNameFilter] =
    useState("");
  const [me, setMe] = useState("");
  const [occasions, setOccasions] = useState([]);

  const [filteredCards, setFilteredCards] = useState({});
  useEffect(() => {
    const token = localStorage.getItem("token");
    const fetchCards = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/card/get-cards`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const data = await res.json();
        setCards(data.data);
      } catch (error) {
        console.error("Failed to fetch cards:", error);
      } finally {
      }
    };
    if (token) {
      fetchCards();
    }
  }, []);
  useEffect(() => {
    const fetchOccasion = async () => {
      const token = localStorage?.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/event/get-active-event`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const res = await response.json();
      const status = res.code;
      if (status === 200) {
        setOccasions(res.data);
      }
    };
    fetchOccasion();
  }, []);

  useEffect(() => {
    if (selectedMonthFilter) {
      const [selectedYear, selectedMonth] = selectedMonthFilter.split("-");

      // Check if the year exists in groupedCards and the month exists within that year
      if (
        groupedCards[selectedYear] &&
        groupedCards[selectedYear][selectedMonth]
      ) {
        setFilteredCards({
          [selectedYear]: {
            [selectedMonth]: groupedCards[selectedYear][selectedMonth],
          },
        });
      } else {
        setFilteredCards(groupedCards);
      }
    } else {
      // If no filter is selected, show all groupedCards
      setFilteredCards(groupedCards);
    }
  }, [groupedCards, selectedMonthFilter]);
  console.log(groupedCards);
  useEffect(() => {
    const token = localStorage.getItem("token");
    const fetchMe = async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/me`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-sh-auth": token,
        },
      });
      const data = await res.json();
      if (res.status === 200) {
        setMe(data.detail.fullName);
        setFav(data.detail.favoriteCards);
      }
    };
    if (token) {
      fetchMe();
    }
  }, []);

  const generateCard = async (card) => {
    const name = card?.receiptsId?.fullName;
    const recipientID = card?.receiptsId?._id;
    const relationship = card?.receiptsId?.relationShip;
    const eventId = card?.eventId;
    const birthday =
      card?.receiptsId?.dob && format(card?.receiptsId?.dob, "yyyy-MM-dd");
    const gender = card?.receiptsId?.gender;
    const character_traits = card?.receiptsId?.characterTraits;
    const messageTheme = card?.messageTheme;
    const selectedCard = card?.cardId.thumbnail;
    const selectedCardID = card?.cardId._id;
    const occasion = occasions.find((o) => o._id === card?.eventId)?.name;
    const greetings = card?.textTo;
    const text = card?.textCard;
    const signoff = card?.textFrom;
    const EventOfRecipientId = card?._id;
    const eventDate = card?.eventDate;

    if (
      !name ||
      !recipientID ||
      !relationship ||
      !eventId ||
      !birthday ||
      !gender ||
      !character_traits ||
      !messageTheme ||
      !selectedCard ||
      !selectedCardID ||
      !me ||
      !occasion ||
      !greetings ||
      !text ||
      !EventOfRecipientId ||
      !signoff
    ) {
      console.log("Missing data");
    } else {
      window.location.href =
        "/dashboard/card_generation/pick?name=" +
        name +
        "&recipientID=" +
        recipientID +
        "&relationship=" +
        relationship +
        "&occasion=" +
        occasion +
        "&eventId=" +
        eventId +
        "&birthday=" +
        birthday +
        "&gender=" +
        gender +
        "&character_traits=" +
        character_traits +
        "&messageTheme=" +
        messageTheme +
        "&me=" +
        me +
        "&thumbnail=" +
        selectedCard +
        "&selectedCardID=" +
        selectedCardID +
        "&greetings=" +
        greetings +
        "&text=" +
        text +
        "&signoff=" +
        signoff +
        "&eventOfRecipientId=" +
        EventOfRecipientId +
        "&fromNavigatedPageName=Draft" +
        "&page=3&eventDate=" +
        eventDate;
    }
  };

  const groupCardsByMonthAndRecipient = (cards) => {
    const grouped = {};
    cards.forEach((card) => {
      const month = new Date(card.eventDate).toLocaleString("default", {
        month: "long",
      });
      const recipientName = card.receiptsId.fullName; // Adjust based on your data structure
      if (!grouped[month]) {
        grouped[month] = {};
      }
      if (!grouped[month][recipientName]) {
        grouped[month][recipientName] = [];
      }
      grouped[month][recipientName].push(card);
    });
    return grouped;
  };

  // Generate a sorted list of months starting from the current month
  const generateSortedMonths = () => {
    const monthOrder = [];
    const currentMonth = new Date().getMonth();
    for (let i = 0; i < 12; i++) {
      const monthName = new Date(0, (currentMonth + i) % 12).toLocaleString(
        "default",
        { month: "long" }
      );
      monthOrder.push(monthName);
    }
    return monthOrder;
  };

  const groupCardsByYearAndMonth = useCallback((cards) => {
    return cards.reduce((grouped, card) => {
      const adjustedEventDate = getAdjustedEventDate(
        card.eventDate,
        card.createdAt,
        {},
        card
      );
      const year = adjustedEventDate.getFullYear();
      const month = adjustedEventDate.toLocaleString("default", {
        month: "long",
      });

      if (!grouped[year]) {
        grouped[year] = {};
      }

      if (!grouped[year][month]) {
        grouped[year][month] = [];
      }

      grouped[year][month].push(card);

      return grouped;
    }, {});
  }, []);
  const sortMonths = (months) => {
    const monthOrder = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const currentMonthIndex = new Date().getMonth();

    const sortedMonths = [
      ...monthOrder.slice(currentMonthIndex),
      ...monthOrder.slice(0, currentMonthIndex),
    ];

    return months.sort(
      (a, b) => sortedMonths.indexOf(a) - sortedMonths.indexOf(b)
    );
  };
  useEffect(() => {
    if (customerCards.length > 0) {
      const grouped = groupCardsByYearAndMonth(customerCards);
      const sortedGroupedCards = Object.keys(grouped).reduce((acc, year) => {
        const months = Object.keys(grouped[year]);
        const sortedMonths = sortMonths(months);
        acc[year] = sortedMonths.reduce((monthAcc, month) => {
          monthAcc[month] = grouped[year][month];
          return monthAcc;
        }, {});
        return acc;
      }, {});

      setGroupedCards(sortedGroupedCards);
    }
  }, [customerCards, groupCardsByYearAndMonth]);

  useEffect(() => {
    setLoader(true);
    const token = localStorage.getItem("token");
    const fetchCards = async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/eventOfRecipient/get-customer-cards?status=draft`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const data = await res.json();
      setTimeout(() => {
        setLoader(false);
      }, 2000);
      setCustomerCards(data.data);
    };
    if (token) {
      fetchCards();
    }
  }, []);

  const favoriteCards = cards.filter((card) => fav.includes(card._id));
  return (
    // <section className="flex max-w-[1200px] mx-auto gap-2">
    <section className="flex mx-auto px-4 sm:px-2">
      {/* <div className="w-full"> */}
      <SidePanel />
      <div className="w-full xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
        <h1 className="text-4xl text-secondary font-bold sm:text-left text-center mb-5">
          Favorites
        </h1>
        {/* Loader or Content Favourite*/}
        {loader ? (
          <div className="h-full flex items-center justify-center">
            <Spinner props="Loading..." size={80} />
          </div>
        ) : Object.keys(favoriteCards).length === 0 ? (
          <div className="flex flex-col items-center justify-center my-10 h-[40%]">
            <img src={draft_img} alt="draft" width={400} />
            <h3 className="text-xl my-10">Empty in favourites.</h3>
          </div>
        ) : (
          <div className="px-4 py-2 mb-6 bg-gray-100 rounded-xl shadow-sm">
            <MultiSwiper reffs={"erererer"}>
              {favoriteCards.map((card, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="relative border-transparent cursor-pointer rounded-md hover:border hover:border-primary hover:shadow-md transition duration-300 ease-in-out"
                    key={index}
                    onClick={() => {
                      setSelectedCardAddPop(card.thumbnail);
                      setSelectedCardID(card._id);
                      toggleOrderModal();
                    }}
                  >
                    <img
                      src={card.thumbnail}
                      alt="Card thumbnail"
                      className="rounded-md shadow-lg"
                      // width={850}
                    />
                    {/* <button
                            onClick={() => generateCard(card)}
                            className="mt-3 w-full py-2 rounded-md border-2 border-primary text-primaborder-primary hover:bg-primary-light"
                          >
                            View
                          </button> */}
                  </div>
                </SwiperSlide>
              ))}
            </MultiSwiper>
          </div>
        )}
        <h1 className="text-4xl text-secondary font-bold sm:text-left text-center mt-4">
          Drafts
        </h1>
        {/* Filter Section */}
        <div className="flex flex-col items-start justify-between gap-5 lg:flex-row lg:gap-0">
          <div className="flex flex-col lg:w-[35%] w-full">
            <div className="flex items-center w-full gap-x-4">
              <select
                value={selectedMonthFilter}
                onChange={(e) => setSelectedMonthFilter(e.target.value)}
                className="w-full py-3 border-b-2 bg-white border-primary placeholder:text-gray-300 focus:border-primary active:border-primary"
              >
                <option value="">Filter by Month</option>
                {Object.keys(groupedCards).map((year) =>
                  Object.keys(groupedCards[year]).map((month) => (
                    <option key={`${year}-${month}`} value={`${year}-${month}`}>
                      {month} {year}
                    </option>
                  ))
                )}
              </select>
            </div>
          </div>
        </div>
        {/* Loader or Content Draft */}
        {loader ? (
          <div className="h-full flex items-center justify-center">
            <Spinner props="Loading..." size={80} />
          </div>
        ) : Object.keys(filteredCards).length === 0 ? (
          <div className="flex flex-col items-center justify-center my-10 h-[40%]">
            <img src={draft_img} alt="draft" width={400} />
            <h3 className="text-xl my-10">
              Empty in drafts, generate a card and save it to drafts.
            </h3>
          </div>
        ) : (
          Object.entries(filteredCards).map(([year, monthData]) => {
            return (
              <div key={year}>
                {monthData === null ? (
                  <div>No data</div>
                ) : (
                  Object.entries(monthData).map(([month, cards]) => (
                    <div key={`${month}-${year}`} className="mb-4">
                      <h1 className="text-xl md:text-2xl font-bold my-2">
                        {month} {year}
                      </h1>
                      <div className="px-4 py-2 mb-6 bg-gray-100 rounded-xl shadow-sm">
                        <MultiSwiper reffs={month} key={month}>
                          {cards?.map((card, index) => {
                            const adjustedEventDate = getAdjustedEventDate(
                              card?.eventDate,
                              card?.createdAt,
                              {},
                              card
                            );

                            return (
                              <SwiperSlide key={index}>
                                <div className="relative">
                                  <img
                                    src={card?.cardId?.thumbnail}
                                    alt="Card thumbnail"
                                    className="rounded-md shadow-lg"
                                  />
                                  <button
                                    onClick={() => generateCard(card)}
                                    className="mt-3 w-full py-2 rounded-md border-2 border-primary text-primary hover:bg-primary-light"
                                  >
                                    View
                                  </button>
                                </div>
                              </SwiperSlide>
                            );
                          })}
                        </MultiSwiper>
                      </div>
                    </div>
                  ))
                )}
              </div>
            );
          })
        )}
        ;
      </div>

      {orderModal && (
        <GenerateCardPopup
          toggleOrderModal={toggleOrderModal}
          selectedCard={selectedCardAddPop}
          selectedCardID={selectedCardID}
        />
      )}
    </section>
  );
};

export default Draft;

// (
//   <div>
//     {Object.entries(filteredCards).map(([month, recipients]) => (
//       <React.Fragment   key={month}>

//         <h2 className="text-2xl font-bold my-2">{month}</h2>{" "}
//       <div

//         className="relative py-1 px-5 mt-3 w-full rounded-xl bg-gray-100 shadow-sm"
//       >
//         {/* {Object.entries(recipients).map(
//           ([recipientName, recipientCards]) => (
//             <div key={recipientName} className="relative">
//               <h3 className="text-xl font-semibold mb-2">
//                 {recipientName}
//               </h3>
//               <div
//                 className="swiper-button-prev absolute top-1/2 left-0 transform -translate-y-1/2 z-10 bg-primary text-white rounded-full w-10 h-10 flex items-center justify-center cursor-pointer"
//                 onClick={() =>
//                   swiperRef.current[recipientName].swiper.slidePrev()
//                 } // Navigate to previous slide
//               ></div>
//               <Swiper
//                 ref={(el) => (swiperRef.current[recipientName] = el)}
//                 modules={[Navigation, Pagination, Scrollbar, A11y]}
//                 slidesPerView={1} // Initially, show one card
//                 spaceBetween={40} // Spacing between cards
//                 breakpoints={{
//                   640: { slidesPerView: 1 }, // Show 1 card on small screens
//                   768: { slidesPerView: 2 }, // Show 2 cards on medium screens
//                   1024: { slidesPerView: 3 }, // Show 3 cards on large screens
//                 }}
//                 navigation={false}
//                 style={{ paddingBottom: "40px", padding: "10px" }} // Add padding to avoid navigation overlap
//               >
//                 {recipientCards.map((card, index) => (
//                   <SwiperSlide key={recipientName}>
//                     <div className="relative p-8" key={index}>
//                       <img
//                         src={card.cardId.thumbnail}
//                         alt="Card thumbnail"
//                         className="rounded-md shadow-lg"
//                         // width={250}
//                       />
//                       <button
//                         onClick={() => generateCard(card)}
//                         className="mt-3 w-full py-2 rounded-md border-2 border-primary text-primaborder-primary hover:bg-primary-light"
//                       >
//                         View
//                       </button>
//                     </div>
//                   </SwiperSlide>
//                 ))}
//               </Swiper>{" "}
//               <div
//                 className="swiper-button-next absolute top-1/2 right-0 transform -translate-y-1/2 z-10 bg-primary text-white rounded-full w-10 h-10 flex items-center justify-center cursor-pointer"
//                 onClick={() =>
//                   swiperRef.current[recipientName].swiper.slideNext()
//                 } // Navigate to next slide
//               ></div>
//             </div>
//           )
//         )} */}{" "}
//         {Object.entries(recipients).map(
//           ([recipientName, recipientCards]) => (
//             <div key={recipientName} className="relative">
//               {/* <h3 className="text-xl font-semibold mb-2">
//                 {recipientName}
//               </h3> */}

//               {/* Custom Previous Button */}
//               {/* <div
//                 className="swiper-button-prev absolute top-1/2 left-0 transform -translate-y-1/2 z-10 bg-primary text-white rounded-full w-10 h-10 flex items-center justify-center cursor-pointer"
//                 onClick={
//                   () => swiperRef.current[recipientName]?.slidePrev() // Navigate to previous slide
//                 }
//               ></div> */}
//               {/* <img
//                 className="react-swiper-prev cursor-pointer absolute top-1/2 left-20"
//                 onClick={() =>
//                   swiperRef.current[recipientName]?.slidePrev()
//                 } // Go to previous slide
//                 src={leftCaraousal}
//                 alt=""
//               ></img> */}
//               <div
//                 onClick={() =>
//                   swiperRef.current[recipientName]?.slidePrev()
//                 } // Go to previous slide
//                 className={` absolute top-[40%] left-6 md:left-12 transform translate-y-1/2 z-10 bg-primary text-white rounded-full w-10 h-10 flex items-center justify-center cursor-pointer
//       `}
//               >
//                 <MdChevronLeft size={24} />{" "}
//                 {/* react-icon for Left Arrow */}
//               </div>
//               <div className="px-16">
//                 <Swiper
//                   onSwiper={(swiperInstance) => {
//                     swiperRef.current[recipientName] = swiperInstance; // Store Swiper instance
//                   }}
//                   modules={[Navigation, Pagination, Scrollbar, A11y]}
//                   slidesPerView={1} // Initially, show one card
//                   spaceBetween={40} // Spacing between cards
//                   breakpoints={{
//                     640: { slidesPerView: 1 }, // Show 1 card on small screens
//                     768: { slidesPerView: 2 }, // Show 2 cards on medium screens
//                     1024: { slidesPerView: 3 }, // Show 3 cards on large screens
//                   }}
//                   navigation={false} // Disable default navigation
//                   style={{
//                     paddingBottom: "40px",
//                     padding: "10px",
//                     width: "70%",
//                   }} // Add padding to avoid navigation overlap
//                 >
//                   {recipientCards.map((card, index) => (
//                     <SwiperSlide key={card.cardId + index}>
//                       <div className="relative">
//                         <img
//                           src={card.cardId.thumbnail}
//                           alt="Card thumbnail"
//                           className="rounded-md shadow-lg"
//                         />
//                         <button
//                           onClick={() => generateCard(card)}
//                           className="mt-3 w-full py-2 rounded-md border-2 border-primary text-primary hover:bg-primary-light"
//                         >
//                           View
//                         </button>
//                       </div>
//                     </SwiperSlide>
//                   ))}
//                 </Swiper>
//               </div>
//               {/* Custom Next Button */}
//               {/* <div
//                 className="swiper-button-next absolute top-1/2 right-0 transform -translate-y-1/2 z-10 bg-primary text-white rounded-full w-10 h-10 flex items-center justify-center cursor-pointer"
//                 onClick={
//                   () => swiperRef.current[recipientName]?.slideNext() // Navigate to next slide
//                 }
//               ></div> */}
//               {/* <img
//                 className="react-swiper-next cursor-pointer absolute top-1/2 right-0"
//                 onClick={
//                   () => swiperRef.current[recipientName]?.slideNext() // Navigate to next slide
//                 }
//                 src={rightCaraousal}
//                 alt=""
//               ></img> */}
//               <div
//                 className={`absolute top-[40%] right-6 md:right-12 transform translate-y-1/2 z-10 bg-primary text-white rounded-full w-10 h-10 flex items-center justify-center cursor-pointer
//        `}
//                 onClick={() =>
//                   swiperRef.current[recipientName]?.slideNext()
//                 }
//               >
//                 <MdChevronRight size={24} />{" "}
//                 {/* react-icon for Right Arrow */}
//               </div>
//             </div>
//           )
//         )}
//       </div>
//       </React.Fragment>
//     ))}
//   </div>
// )}
